import classNames from "classnames";
import React, { useState } from "react";
import { UseFormRegister } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";

type Inputs = any;
interface Props {
  register: UseFormRegister<Inputs>;
  errors: any;
  name: string;
  label: string;
  translateId?: string;
  disabled?: boolean;
  printEnabled?: boolean;
}

const TextArea: React.FC<Props> = ({
  name,
  register,
  errors,
  label,
  translateId,
  disabled,
  printEnabled = false,
}) => {
  const [numOfChar, setNumOfChar] = useState(0);
  const { t } = useTranslation();
  return (
    <div className="relative grid md:grid-cols-2 grid-cols-1 w-full gap-[5px] md:gap-0">
      <label htmlFor={name} className="font-normal text-xl text-[#1E408E] pr-9">
        <Trans t={t}>{label}</Trans>
      </label>
      <div
        className={classNames("flex flex-col  pr-10", {
          printEnabled: "pr-0",
        })}
      >
        <div className="flex flex-row justify-between gap-x-4">
          <div className="flex relative bg-green-400">
            <textarea
              {...register(`${name}`)}
              maxLength={600}
              rows={6}
              cols={100}
              className="border border-[#8692A6] w-full rounded p-2"
              onChange={(e) => setNumOfChar(e.target.value.length)}
              disabled={disabled}
            />
            <span className="absolute bottom-[1px] right-[1px] text-sm pr-[4px] pb-[2px] bg-white">
              {numOfChar}/600
            </span>
          </div>
          {printEnabled && (
            <input
              type="checkbox"
              {...register(`print${name}`)}
              defaultChecked
              id={`${name}`}
            />
          )}
        </div>
        <p className="text-red-500 text-xs">{errors[name]?.message}</p>
      </div>
    </div>
  );
};

export default TextArea;
